<!-- PREMIUM SUCCESS REGISTRATION PAGE - REDESIGNED -->

<ion-content fullscreen class="success-page-premium">

    <!-- SHOW CONTENT ONLY IF DATA EXISTS -->
    <ng-container *ngIf="registrationData; else expiredTemplate">

        <!-- ================================
       HERO SECTION - PREMIUM
       ================================ -->
        <div class="hero-section">
            <!-- Background Image with Gradient Overlay -->
            <div class="hero-background">
                <img *ngIf="registrationData?.event_image" [src]="registrationData.event_image"
                    class="event-banner-image" alt="Event Background" />
                <div class="gradient-overlay"></div>
            </div>

            <!-- Success Beacon (Animated) -->
            <div class="success-beacon">
                <div class="pulse-ring"></div>
                <div class="checkmark-wrapper">
                    <svg class="checkmark-animated" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M4 12L9 17L20 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>

            <!-- Hero Content -->
            <div class="hero-content">
                <h1 class="hero-title">Registration Confirmed</h1>
                <p class="hero-subtitle">Your event access has been successfully generated</p>
            </div>
        </div>

        <!-- ================================
       MAIN CONTENT - ELEVATED CARDS
       ================================ -->
        <div class="content-wrapper">

            <!-- CREDENTIAL CARD - Premium Presentation -->
            <div class="credential-card">
                <div class="card-header-banner"></div>

                <div class="profile-section">
                    <!-- <div class="profile-image-wrapper">
                    <img *ngIf="registrationData?.image" [src]="registrationData.image" class="profile-image"
                        alt="User Profile" />
                    <div class="status-badge" title="Registration confirmed">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                        </svg>
                    </div>
                </div> -->

                    <div class="profile-info">
                        <h2 class="member-name">{{ registrationData?.name }}</h2>
                        <!-- <div class="registration-id-display">
                        <span class="label">Registration ID</span>
                        <div class="id-value-group">
                            <span class="id-value">#{{ registrationData?.mem_id }}</span>
                            <button class="copy-button" (click)="copyToClipboard(registrationData?.mem_id)"
                                title="Copy registration ID">
                                <ion-icon name="copy"></ion-icon>
                            </button>
                        </div>
                    </div> -->
                    </div>
                </div>
            </div>

            <!-- EVENT INFORMATION CARD -->
            <div class="event-card">
                <div class="card-icon">
                    <mat-icon>calendar_today</mat-icon>
                </div>

                <div class="event-info">
                    <h3 class="event-name">{{ registrationData?.event_name }}</h3>

                    <div class="event-details">
                        <div class="detail-item">
                            <ion-icon name="location-outline"></ion-icon>
                            <span>{{ registrationData?.event_address }}</span>
                        </div>

                        <div class="detail-item" *ngIf="registrationData?.event_date">
                            <mat-icon>calendar_today</mat-icon>
                            <span>{{ registrationData?.event_date | date:'mediumDate' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- STATUS & CONFIRMATION DETAILS -->
            <!-- <div class="confirmation-grid">
            Status Card
            <div class="info-card status-card">
                <div class="card-label">Status</div>
                <div class="card-value">
                    <span class="status-badge-inline success">
                        <span class="badge-dot"></span>
                        Confirmed
                    </span>
                </div>
            </div>

            Member ID Card
            <div class="info-card">
                <div class="card-label">Member ID</div>
                <div class="card-value">{{ registrationData?.mem_id }}</div>
            </div>

            Event ID Card
            <div class="info-card">
                <div class="card-label">Event ID</div>
                <div class="card-value">{{ registrationData?.event_id }}</div>
            </div>

            Confirmation Date Card
            <div class="info-card">
                <div class="card-label">Confirmed On</div>
                <div class="card-value">{{ registrationData?.confirmed_date | date:'short' }}</div>
            </div>
        </div> -->

            <!-- SUCCESS MESSAGE - Trust Building -->
            <div class="success-message-premium">
                <div class="message-icon">
                    <mat-icon>check_circle_outline</mat-icon>
                </div>
                <div class="message-content" [innerHTML]="registrationData?.message"></div>
            </div>

            <!-- DIGITAL ID CARD SECTION -->
            <div class="id-card-section">
                <div class="section-header">
                    <h3>Your Digital ID Card</h3>
                    <p class="section-subtitle">Download and keep your official event access card</p>
                </div>

                <!-- ID Card Preview -->
                <div class="id-card-container">
                    <img *ngIf="registrationData?.card_image" [src]="registrationData.card_image + '?v=' + cacheBuster" class="id-card-image"
                        alt="Digital ID Card" />
                </div>

                <!-- ID Card Actions -->
                <div class="card-actions">
                    <button class="btn btn-primary btn-large btn-full" (click)="downloadCard()">
                        <ion-icon name="download-outline" slot="start"></ion-icon>
                        Download ID Card
                    </button>

                    <button class="btn btn-secondary btn-large btn-full" (click)="shareCard()">
                        <ion-icon name="share-social-outline" slot="start"></ion-icon>
                        Share Registration
                    </button>
                </div>
            </div>

            <!-- NEXT STEPS - Contextual Actions -->
            <div class="next-steps-section">
                <div class="section-header">
                    <h3>What's Next?</h3>
                </div>

                <div class="steps-list">
                    <div class="step-item">
                        <div class="step-number">1</div>
                        <div class="step-content">
                            <h4>Download Your ID Card</h4>
                            <p>Save your digital pass for easy event access</p>
                        </div>
                    </div>

                    <div class="step-item">
                        <div class="step-number">2</div>
                        <div class="step-content">
                            <h4>Check Your Email</h4>
                            <p>Confirmation details and event information sent to your email</p>
                        </div>
                    </div>

                    <div class="step-item">
                        <div class="step-number">3</div>
                        <div class="step-content">
                            <h4>Show Your QR Code</h4>
                            <p>Present your ID card at event entry for quick check-in</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- PRIMARY CTA SECTION -->
            <div class="action-buttons-premium">
                <button class="btn btn-primary btn-large btn-full" (click)="newRegistration()">
                    <ion-icon name="add-circle-outline" slot="start"></ion-icon>
                    Register Another Person
                </button>

                <button class="btn btn-secondary btn-large btn-full" (click)="goHome()">
                    <ion-icon name="arrow-undo-outline" slot="start"></ion-icon>
                    Back to Website
                </button>
            </div>

            <!-- TRUST FOOTER -->
            <div class="trust-footer">
                <div class="trust-item">
                    <ion-icon name="shield-checkmark"></ion-icon>
                    <span>Your data is encrypted and secure</span>
                </div>
                <div class="trust-item">
                    <ion-icon name="help-circle"></ion-icon>
                    <a href="/support">Need help? Contact support</a>
                </div>
            </div>

        </div>

    </ng-container>

    <!-- EXPIRED / CLEARED STATE -->
    <ng-template #expiredTemplate>
        <div class="expired-wrapper">

            <!-- Background Decorative Elements -->
            <div class="bg-circle bg-circle-1"></div>
            <div class="bg-circle bg-circle-2"></div>

            <!-- Card -->
            <div class="expired-card">

                <!-- Icon -->
                <!-- <div class="expired-icon">
              <mat-icon>hourglass_empty</mat-icon>
                </div> -->

                <!-- Content -->
                <div class="expired-content">

                    <span class="expired-badge">
                        Session Timeout
                    </span>

                    <h2>Your Session Has Expired</h2>

                    <p>
                        For security reasons, your registration details are no longer available.
                        Please return to the website and start again.
                    </p>

                </div>

                <!-- Action -->
                <button class="btn-home" (click)="goHome()">
                    <ion-icon name="home-outline"></ion-icon>
                    <span>Back to Website</span>
                </button>

            </div>

        </div>
    </ng-template>

</ion-content>